import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Components } from '@ionic/core';
import { FirestoreService } from 'src/services/firestore.service';
import { addIcons } from "ionicons";
import { closeCircleOutline } from "ionicons/icons";

@Component({
    selector: 'app-tags',
    templateUrl: 'tags.component.html',
    styleUrls: ['tags.component.scss']
})
export class TagsComponent {

    //items = ["Error"]

    @Input() modal: Components.IonModal;

    checked
    isBankAccount

    tagInput: string = ""

    tags: Array<string> = []

    constructor(
        public firestoreService: FirestoreService
    ) {
      addIcons({closeCircleOutline})
    }

    ngOnInit() {
        this.checked.forEach(i => {
            let tags
            if (this.isBankAccount) {
                tags = this.firestoreService.bankAccountsLocal[i].tags
            } else {
                tags = this.firestoreService.paginatedTransactions[i].tags
            }
            if (tags && tags.length) {
                tags.forEach(tag => {
                    if (!this.tags.includes(tag)) {
                        this.tags.push(tag)
                    }
                })
            }
        })
    }

    addTag() {
        if (this.tagInput) {
            this.tags.push(this.tagInput)
            this.tagInput = ""
        }
    }

    removeTag(index: number) {
      this.tags = [...this.tags.slice(0, index), ...this.tags.slice(index + 1)]
    }

    dismissModal() {
        this.modal.dismiss()
    }

    async submitTags() {
        console.log(this.checked)
        for (let checked of this.checked) {
            console.log(checked)
            if (this.isBankAccount) { //it's a bank account
                console.log(this.firestoreService.bankAccountsLocal[checked])
                await this.firestoreService.updateBankAccount(this.firestoreService.bankAccountsLocal[checked].bankId, { tags: this.tags })
            } else { //it's a transaction
                console.log(this.firestoreService.currentBank.bankId, this.firestoreService.paginatedTransactions[checked].id, { tags: this.tags })
                this.firestoreService.paginatedTransactions[checked].tags = this.tags
                await this.firestoreService.updateTransaction(this.firestoreService.currentBank.bankId, this.firestoreService.paginatedTransactions[checked].id, { tags: this.tags })
            }
        }
        this.dismissModal()
    }

}
